import { DateTime } from 'luxon'
import { i18n } from '../main'

export function convertToRelativeTime(
  isoDate: string,
  intervalsInWords?: true
): string {
  // Get the current date and time
  const currentDateTime = DateTime.now()

  // Convert the ISO date string to DateTime
  const givenDateTime = DateTime.fromISO(isoDate)

  // Calculate the time difference
  const timeDifference = currentDateTime.diff(givenDateTime)

  // Convert the time difference to seconds
  const seconds = timeDifference.as('seconds')

  // Define the time intervals with their corresponding i18n keys
  const intervalsAbbreviations: [string, number][] = [
    ['year', 31536000], // seconds in a year
    ['month', 2592000], // seconds in a month
    ['week', 604800], // seconds in a week
    ['day', 86400], // seconds in a day
    ['hour', 3600], // seconds in an hour
    ['minute', 60], // seconds in a minute
    ['second', 1], // seconds
  ]

  const intervalsWords: [string, number][] = [
    ['years', 31536000],
    ['months', 2592000],
    ['weeks', 604800],
    ['days', 86400],
    ['hours', 3600],
    ['minutes', 60],
    ['seconds', 1],
  ]

  const intervals = intervalsInWords ? intervalsWords : intervalsAbbreviations

  // Generate the relative time expression
  if (seconds < 1) {
    return i18n.global.t('time.justNow')
  }

  const getUnitKey = (unit: string): string => {
    return `time.units.${unit}`
  }

  for (const [unit, intervalSeconds] of intervals) {
    if (seconds >= intervalSeconds) {
      const value = Math.floor(seconds / intervalSeconds)
      const unitKey = getUnitKey(unit)

      return intervalsInWords
        ? i18n.global.t('time.timeAgoFull', {
            value,
            unit: i18n.global.t(unitKey),
          })
        : i18n.global.t('time.timeAgo', {
            value,
            unit: i18n.global.t(unitKey),
          })
    }
  }

  return i18n.global.t('time.justNow')
}
